export enum Spread {
  Tree,
  Opposing,
}

export const getSkillNodeDirection = (
  index: number,
  { overridePlacement, offset, spread = Spread.Tree }: { overridePlacement?: number[]; offset: number; spread: Spread },
) => {
  if (overridePlacement && overridePlacement.length > 0) {
    return overridePlacement[index % overridePlacement.length];
  }
  // Tree structure
  // const placement = [0, 1, 7, 2, 6, 3, 5, 4];

  // Spreading
  // const placement = [0, 4, 6, 2, 7, 3, 1, 5];

  let placement: number[];

  switch (spread) {
    case Spread.Tree:
      placement = [0, 1, 7, 2, 6, 3, 5, 4];
      break;

    case Spread.Opposing:
      placement = [0, 4, 6, 2, 7, 3, 1, 5];
      break;

    default:
      placement = [0, 1, 7, 2, 6, 3, 5, 4];
      break;
  }

  return (placement[index] + offset) % placement.length;
};
